import { useFormik } from "formik";
import { useEffect, useState } from "react";
import axiosInstance from "../../Services/axiosCommon";
import { useToast } from "../Others/ToastServices";
import { NuInputSetting } from "../Utils/Input";
import { TextMediumXS } from "../Text/MediumText";

const SettingsMetaData = ({ propertyName, viewPropertyName }) => {
  const [data, setData] = useState([]);
  const toast = useToast();
  const [createNew, setCreateNew] = useState({
    property: `${propertyName}`,
    value: ""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      axiosInstance.post(`/dropdown/create-dropdown`, value)
        .then(res => {
          if (res.data) {
            resetForm();
            GetData();
            toast.open({
              type: "success",
              message: `${createNew?.property} added successfully`,
            });
          } else {
            toast.open({
              type: "error",
              message: `${createNew?.property} add failed`,
            });
          }
        })
        .catch(error => {
          console.error("Create Error:", error);
          toast.open({
            type: "error",
            message: `Failed to add ${createNew?.property}`,
            description: error.response?.data?.message || 'Something went wrong.',
          });
        });
    },
  });

 const GetData = async () => {
  axiosInstance.get(`/dropdown/dropdown-details/${createNew?.property}`)
    .then(res => {
      let responseData = res.data?.data[createNew?.property];
      if (responseData) {
          const sortedData = responseData.sort((a, b) => {
          return a.value.localeCompare(b.value);
        });
        setData(sortedData);
      } else {
        setData([]);
      }
    })
    .catch(error => {
      console.error("Get Data Error:", error);
      toast.open({
        type: "error",
        message: `Failed to fetch ${createNew?.property} data`,
        description: error.response?.data?.message || 'Something went wrong.',
      });
    });
}


  const handleDelete = (value) => {
    axiosInstance.delete(`/dropdown/remove-value/${createNew?.property}/${value}`)
      .then(res => {
        if (res?.status === 200) {
          GetData();
          toast.open({
            type: "success",
            message: `${createNew?.property} deleted successfully`,
          });
        } else {
          toast.open({
            type: "error",
            message: `${createNew?.property} delete failed`,
          });
        }
      })
      .catch(error => {
        console.error("Delete Error:", error);
        toast.open({
          type: "error",
          message: `Failed to delete ${createNew?.property}`,
          description: error.response?.data?.message || 'Something went wrong.',
        });
      });
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="w-full">
      <form onSubmit={formik.handleSubmit}>
        <div className={`w-full text-xs`}>
          <div className="px-3 mb-1">
            <label className="font-medium text-textColor-500">
              {viewPropertyName}
            </label>
            <NuInputSetting
              type="text"
              placeholder={viewPropertyName}
              formik={formik}
              name="value"
            />
          </div>
        </div>
      </form>

      <div className="px-3">
        <div className="w-full rounded-lg h-44 bg-[#f5f3ff] border border-gray-300 overflow-x-hidden overflow-y-auto">
          <ul>
            {data.map((List, idx) => (
              <li
                className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50"
                key={idx}
              >
                <TextMediumXS color={"text-[#697565]"} content={List.value || "-"} />
                {List?.isDefault === true ? null : List?.value && (
                  <span
                    onClick={() => handleDelete(List?.value)}
                    className="text-blue-900 cursor-pointer"
                  >
                    x
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SettingsMetaData;
